import clsx from "clsx";
import { Fragment } from "react";
import { HeroTitle, TextBadge } from "components/atoms/Text";
import { Checklist } from "components/atoms/Checklist";
import { PrimaryButton, SurfaceButton } from "components/atoms/Button";

const Hero = () => {
    const listCheck = ["Reliable premium proxies", "Ideal for traffic-intensives tasks", "2M+ IPs from 160 countries"];
    return (
        <Fragment>
            <header className={clsx(
                "w-full max-w-[1440px] mx-auto",
                "flex flex-col tablet:flex-row desktop:flex-row justify-between",
                "px-6 tablet:px-8 desktop:px-[120px] tablet:pb-[48px] pb-[88px] phone:pb-0",
            )}>
                <div className={clsx(
                    "w-full tablet:max-w-[550px] pl-2 desktop:max-w-[550px]",
                    "tablet:mt-[75px] mt-[102px] phone:mt-8"
                )}>
                    <TextBadge>SOCKSv5 Proxy</TextBadge>
                    <HeroTitle>SOCKSv5 Proxy</HeroTitle>
                    <div className="mt-4 flex flex-col space-y-4">
                        {listCheck.map((item, idx) => (
                            <Checklist key={idx} text={item} />
                        ))}
                    </div>
                    <div className={clsx(
                        "w-full flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0",
                        "mt-10 phone:mt-8 tablet:mt-8"
                    )}>
                        <PrimaryButton>Get Started</PrimaryButton>
                        <SurfaceButton>See Pricing</SurfaceButton>
                    </div>
                </div>
                <div className={clsx(
                    "w-full pr-2 tablet:max-w-[452px] max-w-[520px]",
                    "phone:mt-10 mt-8 tablet:mt-6 phone:mb-12"
                )}>
                    <img src="/images/proxy/socks.svg" className="w-[520px] phone:h-[310px] h-[494px] tablet:w-[452px] tablet:h-[429px]" alt="proxy-hero" />
                </div>
            </header>
        </Fragment>
    );
};

export default Hero;